(function () {
  var STORAGE_KEY = 'mediora_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch (e) { return []; }
  }

  function saveWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function findIndex(list, id) {
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].id || list[i]) === String(id)) return i;
    }
    return -1;
  }

  function isInWishlist(id) {
    return findIndex(getWishlist(), id) > -1;
  }

  function toggleItem(id, productData) {
    var list = getWishlist();
    var idx = findIndex(list, id);
    if (idx > -1) {
      list.splice(idx, 1);
    } else {
      list.push(productData || { id: String(id) });
    }
    saveWishlist(list);
  }

  function updateNavBadge() {
    var badge = document.querySelector('[data-wishlist-count]');
    if (!badge) return;
    var count = getWishlist().length;
    badge.textContent = count;
    if (count > 0) {
      badge.removeAttribute('hidden');
    } else {
      badge.setAttribute('hidden', '');
    }
  }

  function setButtonState(btn, active) {
    var svg = btn.querySelector('svg');
    if (active) {
      btn.classList.add('is-active');
      if (svg) {
        svg.setAttribute('fill', '#5FC5BD');
        svg.setAttribute('stroke', '#5FC5BD');
      }
    } else {
      btn.classList.remove('is-active');
      if (svg) {
        svg.setAttribute('fill', 'none');
        svg.setAttribute('stroke', 'currentColor');
      }
    }
  }

  function initButtons() {
    document.querySelectorAll('[data-wishlist-btn]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      if (!id) return;

      setButtonState(btn, isInWishlist(id));

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var productData = {
          id: String(id),
          title: btn.getAttribute('data-product-title') || '',
          variant_id: btn.getAttribute('data-product-variant-id') || '',
          price: parseInt(btn.getAttribute('data-product-price') || '0', 10),
          compare_price: parseInt(btn.getAttribute('data-product-compare-price') || '0', 10),
          image: btn.getAttribute('data-product-image') || '',
          url: btn.getAttribute('data-product-url') || '',
          type: btn.getAttribute('data-product-type') || ''
        };
        toggleItem(id, productData);
        setButtonState(btn, isInWishlist(id));
        updateNavBadge();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initButtons();
    updateNavBadge();
  });
})();
